import React, { useEffect } from 'react';

const DeprecatedDomain = () => {
    const initialize = () => {
        if (window.pendo?.initialize) {
            window.pendo.initialize();
            return;
        }
        // retrying initialize in case pendo has not loaded
        setTimeout(initialize, 300);
    };

    const sendEvent = () => {
        if (window.pendo?.isReady?.()) {
            window.pendo.track('TrackDeprecatedDomainVisit');
            return;
        }
        // retriyng in case pendo has not fully initialized
        setTimeout(sendEvent, 500);
    };

    useEffect(sendEvent, []);
    useEffect(initialize, []);

    return (
        <div
            className="gds-flex gds-flex--direction-col gds-flex--content-center gds-flex--justify-around -text-center"
            style={{
                height: '100vh',
            }}
        >
            <div className="gds-flex__item gds-flex__item--grow-0">
                <i
                    className="fas fa-fw fa-link gds-text--header-xl gds-text--primary fa-rotate-90"
                    style={{
                        fontSize: '6rem',
                    }}
                />
                <i
                    className="fas fa-fw fa-external-link -color-tx-dk-5"
                    style={{
                        fontSize: '2.8rem',
                        position: 'relative',
                        bottom: '3rem',
                        right: '1.5rem',
                    }}
                />
                <p className="gds-text--header-md -m-t-4">
                    There is a new URL to access Relo Edge:
                </p>
                <p className="gds-text--header-md -m-t-2 gds-text--secondary">
                    <a href="https://mvc.relometrics.com">
                        {' '}
                        https://mvc.relometrics.com{' '}
                    </a>
                </p>
                <p className="gds-text--header-md -m-t-2">
                    Please bookmark and start using this new link to login to
                    the MVC.
                </p>
            </div>
        </div>
    );
};

export default DeprecatedDomain;
